import {
  CheckCircleTwoTone,
  DeleteOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import {
  Avatar,
  Button,
  Col,
  message,
  Modal,
  Popconfirm,
  Row,
  Table,
} from "antd";
import { ColumnsType } from "antd/lib/table";
import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  DefaultErrorMessage,
  UpdateDataSuccessfully,
} from "shared/constants/define-localization";
import {
  ADD_PRODUCT_ROUTE,
  UPDATE_PRODUCT_ROUTE,
} from "shared/constants/routes";
import { CoreResource, t } from "shared/plugins/localization";
import {
  redirectFileLocalUrl,
  formatMoney,
} from "shared/plugins/string-helper";
import { setLoading } from "states/global-value/global-value.slice";
import { ProductModel } from "states/product/product.models";

export interface IVariationModalProps {
  model: ProductModel[];
  visible: boolean;
  onClose: (isReloadList?: boolean) => void;
  onReloadModel: (mainProduct: ProductModel) => void;
}

export function VariationModal(props: IVariationModalProps) {
  const { model, visible, onClose } = props;

  const columns: ColumnsType<ProductModel> = [
    {
      title: "Mã hàng",
      dataIndex: "skuCode",
      key: "skuCode",
      width: "150px",
      render: (skuCode: string, item) => skuCode,
    },
    {
      title: "Tên sản phẩm",
      dataIndex: "websiteName",
      key: "websiteName",
      render: (websiteName: string, item) => (
        <React.Fragment>
          <Link to={`${UPDATE_PRODUCT_ROUTE}/${item.id}`}>
            <Avatar
              src={redirectFileLocalUrl(
                item.images.length > 0 ? item.images[0] : ""
              )}
              shape="square"
            />{" "}
            {item.name} (
            {item.variationAttributes.map((m) => m.variationValue).join(", ")})
          </Link>{" "}
          {!item.mainVariationProductId && (
            <CheckCircleTwoTone twoToneColor={["#fff", "#1890ff"]} />
          )}
        </React.Fragment>
      ),
    },
    {
      title: "Giá bán",
      dataIndex: "websiteName",
      key: "websiteName",
      render: (websiteName: string, item) => formatMoney(item.price),
    },
  ];

  return (
    <Modal
      title="Danh sách biến thể sản phẩm"
      visible={visible}
      onCancel={() => {
        onClose();
      }}
      onOk={() => {
        onClose();
      }}
      width={1000}
    >
      <Row gutter={[16, 16]} className="mb-4">
        <Col span={12}>
          <Link
            to={`${ADD_PRODUCT_ROUTE}/${
              model.find((m) => !m.mainVariationProductId)?.id
            }`}
          >
            <Button type="primary" icon={<PlusCircleOutlined />}>
              Thêm biến thể
            </Button>
          </Link>
        </Col>
      </Row>
      <Table
        columns={columns}
        dataSource={model}
        size="small"
        pagination={false}
      ></Table>
    </Modal>
  );
}
